export default __webpack_public_path__ + "static/media/330_business02-nl-web.d1af5da8.png";